<template>
  <v-card
    class="mx-auto"
    max-width="900"
  >
    <v-card-title>
      Error
    </v-card-title>
    <v-card-text>
      <v-row class="align-stretch">
        <v-col
          cols="12"
          sm="4"
          order-sm="2"
        >
          <v-img
            src="@/assets/error/error_message.jpeg"
            contain
            height="120"
          />
        </v-col>

        <v-col
          cols="12"
          sm="8"
          class="d-flex flex-column justify-space-between"
          order-sm="1"
        >
          <div>
            An error occurred. <br />
            Please try again later or email
            <a href="mailto:Support@GlobalCoachGroup.com">
              Support@GlobalCoachGroup.com
            </a>for assistance.
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'RegisterError',
};
</script>
